import { useEffect, useState } from 'react'
import { PANEL_HEIGHT } from '../utils/constants'

export const useMapDimensions = (
  calculateDimensions = () => ({
    height: PANEL_HEIGHT,
    width: (window.innerWidth / 3) * 2,
  }),
) => {
  const [dimensions, setDimensions] = useState(() => calculateDimensions())

  useEffect(() => {
    function handleResize() {
      const newDimensions = calculateDimensions()
      setDimensions(newDimensions)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [calculateDimensions])

  return { mapWidth: dimensions.width, mapHeight: dimensions.height }
}
